/**
 * Tour guide — Section Ticketing.
 */

const ticketingTour = [
  {
    target: null,
    title: 'Bienvenue dans le module Ticketing',
    content: 'Gérez tous les tickets support METERIS : création, suivi, résolution. Vous pouvez filtrer, rechercher, et basculer entre trois vues : Liste, Kanban et Tâches.',
    position: 'bottom',
  },
  {
    target: '[data-tour="tickets-filters"]',
    title: 'Filtres rapides',
    content: 'Boutons pour filtrer en 1 clic : Non résolu, Mes tickets, AMC, ou par statut. Le contenu s\'adapte instantanément.',
    position: 'bottom',
  },
  {
    target: null,  // Modal centré : le bouton est dans la colonne de gauche
    title: '📦 Commandes en attente',
    content: 'Une pièce commandée qui n\'arrive pas ? Le bouton « Commandes en attente » liste toutes les commandes /cmd passées et non reçues, avec le fournisseur et la date d\'arrivée prévue, la plus en retard en tête. Le statut « En attente » d\'un ticket ne le disait pas : il ne distingue pas une attente de pièce d\'une attente de réponse client.',
  },
  {
    target: '[data-tour="tickets-search"]',
    title: 'Recherche avancée',
    content: 'Recherchez par titre, description, référence. Cliquez sur "Recherche avancée" pour croiser plusieurs critères.',
    position: 'bottom',
  },
  {
    target: '[data-tour="view-toggle"]',
    title: 'Vues Liste, Kanban et Tâches',
    content: 'Trois vues : Liste (tableau triable), Kanban (une colonne par statut — glissez une carte pour changer son statut) et Tâches. Votre choix est mémorisé.',
    position: 'bottom',
  },
  {
    target: '[data-tour="tickets-new"]',
    title: 'Créer un ticket',
    content: 'Priorité calculée automatiquement via matrice ITIL (urgence × impact). Catégorie détermine les techniciens destinataires.',
    position: 'left',
    permission: 'ticketing.manage',
  },
  {
    target: null,
    title: 'Actions groupées',
    content: 'Cochez plusieurs tickets (Maj+clic pour une plage) : une barre apparaît pour les affecter, les modifier, les fusionner, les résoudre ou les supprimer en masse.',
    position: 'top',
  },
  {
    target: null,
    title: 'Mentions @ dans un ticket',
    content: 'Tapez @prenom pour taguer quelqu\'un — dans un suivi comme dans une tâche, à l\'écriture comme à la modification. La liste propose l\'équipe METERIS et les contacts de la société du ticket. Un email part au destinataire avec votre message ; un bandeau vous indique avant l\'envoi qui sera prévenu, en orange s\'il s\'agit d\'un client. Le client reçoit un lien vers le rapport du ticket, sans avoir besoin de compte.',
    position: 'center',
  },
  {
    target: null,
    title: '📄 Ce qui part dans le rapport de synthèse',
    content: 'Un suivi ou une tâche public est déjà montré au client et imprimé dans le rapport complet. Cochez « Synthèse » (ou cliquez la puce SYNTHÈSE dans son en-tête) pour l\'imprimer aussi dans le rapport de synthèse, celui qui part au client à la résolution. Aucun mail n\'est envoyé en cochant.',
    position: 'center',
  },
  {
    target: null,  // Modal centré
    title: 'C\'est parti !',
    content: 'Vous connaissez maintenant l\'essentiel. Pour plus de détails, consultez l\'aide contextuelle (bouton ? en bas à droite).',
    position: 'center',
  },
];

export default ticketingTour;
